import { Styles, generateClasses } from 'netline-ui';

export const mobileHeaderClasses = generateClasses('MobileHeader', ['root', 'closeIcon', 'title'] as const);

const styles: Styles = ({ theme: { palette, spacing } }) => ({
  [`&.${mobileHeaderClasses.root}`]: {
    backgroundColor: palette.primary[900],
    padding: spacing(1.5, 2),
    display: 'flex',
    alignItems: 'center',
    gap: spacing(2),
    '.MuiIconButton-root': {
      padding: 2,
    },
  },

  [`.${mobileHeaderClasses.closeIcon}`]: {
    color: palette.common.white,
    width: '20px',
    height: '20px',
  },

  [`.${mobileHeaderClasses.title}`]: {
    color: palette.common.white,
    fontSize: 16,
    lineHeight: '20px',
    letterSpacing: '0.15px',
  },
});

export default styles;
